import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1e764c1c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=1e764c1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e764c1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e764c1c')) {
      api.createRecord('1e764c1c', component.options)
    } else {
      api.reload('1e764c1c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1e764c1c&scoped=true&", function () {
      api.rerender('1e764c1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/big-boss/modules/edit-big-boss-dialog/index.vue"
export default component.exports